import React from "react";
import confirmDelete from "../../assets/Images/confirm delete.png";
import { ReactComponent as Cancel } from "../../assets/Icons/Cancel.svg";
import { CircularProgress } from "@mui/material";
import ConfirmationIcon from "../../assets/Icons/confirmation-popup-icon 1.png";
import LeftCircle from "../../assets/Icons/Left Circle.svg";
import RightCircle from "../../assets/Icons/Right Circle.svg";

const DeleteConfirmationDltModal = ({
  isOpen,
  onClose,
  handleDelete,
  loading,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="modal fade show"
      style={{
        display: "block",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        margin: 0,
      }}
    >
      <div className="modal-dialog">
        <div className="modal-content rounded-[23px]">
          <img
            src={LeftCircle}
            alt="leftImg"
            className="absolute left-0 bottom-0 w-[110px] h-[105px]"
          />
          <img
            src={RightCircle}
            alt="leftImg"
            className="absolute right-0 top-0 w-[110px] h-[105px]"
          />
          <div className="modal-header" style={{ borderBottom: "none" }}>
            <img
              src={ConfirmationIcon}
              alt="add-user"
              className="h-[24px] mr-4"
            />
            <h5 className="modal-title font-medium main-title m-0">
              Are you sure you want to delete?
            </h5>
            <button
              type="button"
              className="btn-close ms-auto cursor-pointer z-20"
              aria-label="Close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body text-center">
            <p className="mt-2">
              Information will be permanently erased and irretrievable
            </p>
          </div>
          <div className="modal-footer justify-content-center border-t-0 mb-2">
            <button
              type="button"
              className="flex btn btn-back w-[133px] h-[33px] !rounded-[8px] !items-center !justify-center !font-medium"
              data-bs-dismiss="modal"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="flex btn btn-submit w-[133px] h-[33px] !rounded-[8px] !items-center !justify-center !font-medium"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "3px",
              }}
              onClick={(e) => handleDelete()}
              disabled={loading}
            >
              {loading && (
                <CircularProgress
                  className="circular-loader"
                  style={{ width: "20px", height: "20px" }}
                />
              )}{" "}
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationDltModal;
